import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Analyse } from 'r/types';
import { captureException, showNotification } from 'r/utils';
import { fetchApiRaw, PUT_ANALYSES_CMS } from 'r/utils/fetchApiRaw';
import { StoredAuth } from 'r/utils/Stored';

export default function useRestoreAnalysis({
  onSuccess,
}: {
  onSuccess?: () => void;
} = {}) {
  const queryClient = useQueryClient();
  const accessTokens = StoredAuth.getAll();

  return useMutation({
    mutationFn: async (analysis: Analyse) => {
      try {
        await fetchApiRaw(
          PUT_ANALYSES_CMS,
          {
            urlParams: [analysis.id],
            body: { deletedAt: null },
          },
          accessTokens.cms,
        );

        return analysis;
      } catch (error) {
        captureException(error);
        throw error;
      }
    },
    onSuccess: () => {
      showNotification('success', 'Analysis restored successfully');
      queryClient.invalidateQueries({ queryKey: ['cms-analyses'] });
      onSuccess?.();
    },
    onError: () => {
      showNotification('error', 'Failed to restore analysis');
    },
  });
}
